// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uW9V5UvCfYIT2yj20ipl>div{min-height:-webkit-fit-content;min-height:fit-content}.JcFHXs2O3Zs6aVTwmqxP{text-align:center}.JQeL4Jn5tD4J4u13uKzh{cursor:pointer}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"questionnaireOrSelectNumberModal": `uW9V5UvCfYIT2yj20ipl`,
	"description": `JcFHXs2O3Zs6aVTwmqxP`,
	"link": `JQeL4Jn5tD4J4u13uKzh`
};
export default ___CSS_LOADER_EXPORT___;
